<div id="solver-template" class="row">
  <select-search-component class="select-search"
    (selectionChange)="onSelectSolverTemplate($event)"
    [label]="'Select a Solver Template'"
    [api_model]="'solver_template'"
    [value]="solverTemplate"
    [classes]="'fill'">
  </select-search-component>
</div>
@if (solverTemplate) {
  <div id="adjusted-type" class="row">
    <select-search-component class="select-search"
      (selectionChange)="adjustedSeriesType=$event.value"
      [label]="'Select an Adjusted Series Type'"
      [api_model]="'series_type'"
      [custom_filters]="adjustedTypesFilter"
      [value]="adjustedSeriesType"
      [classes]="'fill'">
    </select-search-component>
  </div>
}

<div class="row" style="justify-content: space-between;">
  @if (solverTemplate && adjustedSeriesType && !displayData) {
    <button mat-button class="bordered-button solver-button"
      (click)="runSolver()"
      [disabled]="!(solverTemplate && adjustedSeriesType)">Run Solver
    </button>
  }
  <!-- Leaving a duplicate button here in case it becomes a UAT to re-run the solver with different data e.g. with different errors -->
  @if (displayData) {
    <button mat-button class="bordered-button solver-button"
      (click)="runSolver()">Re-run Solver
    </button>
  }

  @if (displayData) {
    <button mat-button class="bordered-button green solver-button" (click)="saveSolvedData()">Save
      Results
    </button>
  }
</div>

@if (running) {
  <div class="stage-item stage">
    <div class="dot-flashing"></div>
  </div>
}

@if (displayData) {
  <solver-data-table class="solver-data-table" [data]="displayData"></solver-data-table>
}
